<template>
  <div class="bgf5" style="padding-bottom: 30px;">
    <div class="width1200 el-row--flex" style="align-items: stretch;">
      <div class="userLeft">
        <div class="userHeader el-row--flex is-justify-center is-align-middle">
          <div class="userHeaderBorder">
            <img src="/static/images/user-default-header.png">
          </div>
          <div class="userHeaderName">{{userName}}</div>
          <div class="userHeaderMobile">{{mobile}}</div>
        </div>
        <div class="userMenu">
          <div class="userMenuItem el-row--flex is-justify-center is-align-middle" :class="{active: tab == 1}"
            @click="tab = 1">
            <img src="/static/images/icon/icon-user-setting.png">
            基础信息
          </div>
          <div class="userMenuItem el-row--flex is-justify-center is-align-middle" :class="{active: tab == 2}"
            @click="tab = 2">
            <img src="/static/images/icon/icon-user-detail.png">
            账户明细
          </div>
        </div>
      </div>
      <div class="userRight">
        <div class="userBody" v-if="tab == 1" style="padding: 57px 18px 39px;">
          <div class="userBodyTag">我的账户</div>
          <div class="userBodyMoney el-row--flex is-align-middle">
            <div class="el-row--flex is-justify-center is-align-middle" style="border-left: none;">
              <div class="userBodyMoneyLabel">账户金额</div>
              <div class="userBodyMoneyNumber el-row--flex is-align-middle">
                {{amount.toFixed(2)}}
                <el-button @click="recharge">充值</el-button>
              </div>
            </div>
            <div class="el-row--flex is-justify-center is-align-middle">
              <div class="userBodyMoneyLabel">赠送金额</div>
              <div class="userBodyMoneyNumber">{{giveAmount.toFixed(2)}}</div>
            </div>
            <div class="el-row--flex is-justify-center is-align-middle">
              <div class="userBodyMoneyLabel">可用金额</div>
              <div class="userBodyMoneyNumber">{{(giveAmount+amount).toFixed(2)}}</div>
            </div>
            <div class="el-row--flex is-justify-center is-align-middle">
              <div class="userBodyMoneyLabel">
                累计消费金额
                <!-- <el-tooltip effect="dark" content="普通用户年消费累计满3000元赠送10%，满5000元赠送20%，满10000元赠送30%，在消费满足条件后次日发放。" placement="right-end">
                  <img src="/static/images/icon/icon-user-question.png" >
                </el-tooltip> -->
              </div>
              <div class="userBodyMoneyNumber">{{consumeAmount.toFixed(2)}}</div>
            </div>
          </div>
        </div>
        <div class="userBody" v-if="tab == 1" style="min-height: calc(100% - 168px);">
          <div class="userBodyTag">账户信息</div>
          <div class="userBodyParam el-row--flex is-justify-space-between is-align-middle">
            <div class="el-row--flex">
              <div class="userBodyParamLabel">手机</div>
              <div class="userBodyParamItem">
                {{mobile}}
              </div>
            </div>
          </div>
          <div class="userBodyParam haveEdit el-row--flex is-justify-space-between is-align-middle">
            <div class="el-row--flex">
              <div class="userBodyParamLabel">公司名称</div>
              <div class="userBodyParamItem">
                {{userName}}
              </div>
            </div>
            <!-- <div class="userBodyFold" :style="{color: !nameEditShow ? '#ff4e4e' : ''}" @click="nameEditShow = !nameEditShow">
              {{nameEditShow ? '收起' : '修改'}}
              <img :style="{transform: nameEditShow ? 'rotateX(180deg)' : ''}" src="/static/images/icon/icon-open.png" >
            </div> -->
          </div>
          <div class="userBodyEdit" v-if="nameEditShow">
            <div class="el-row--flex is-align-middle">
              <div class="userBodyEditLabel">修改公司名称：</div>
              <el-input v-model="nameEdit.userName"></el-input>
            </div>
            <div class="el-row--flex is-align-middle">
              <div class="userBodyEditLabel"></div>
              <el-button type="primary" @click="submit('nameEdit')">保存</el-button>
            </div>
          </div>
          <div class="userBodyParam haveEdit el-row--flex is-justify-space-between is-align-middle">
            <div class="el-row--flex">
              <div class="userBodyParamLabel">密码</div>
              <div class="userBodyParamItem">
                *********
              </div>
            </div>
            <div class="userBodyFold" :style="{color: !passEditShow ? '#ff4e4e' : ''}"
              @click="passEditShow = !passEditShow">
              {{passEditShow ? '收起' : '修改'}}
              <img :style="{transform: passEditShow ? 'rotateX(180deg)' : ''}" src="/static/images/icon/icon-open.png">
            </div>
          </div>
          <div class="userBodyEdit" v-if="passEditShow">
            <div class="el-row--flex is-align-middle">
              <div class="userBodyEditLabel">当前密码：</div>
              <el-input v-model="passEdit.oldPassword" show-password></el-input>
            </div>
            <div class="el-row--flex is-align-middle">
              <div class="userBodyEditLabel">新密码：</div>
              <el-input v-model="passEdit.passWord" show-password></el-input>
            </div>
            <div class="el-row--flex is-align-middle">
              <div class="userBodyEditLabel">确认密码：</div>
              <el-input v-model="passEdit.confirmPassWord" show-password></el-input>
            </div>
            <div class="el-row--flex is-align-middle">
              <div class="userBodyEditLabel"></div>
              <el-button type="primary" @click="submit('passEdit')">保存</el-button>
            </div>
          </div>
        </div>
        <div class="userBody" v-if="tab == 2" style="min-height: calc(100% - 20px);padding: 24px 18px;">
          <el-form :inline="true" :model="filter" class="demo-form-inline">
            <el-form-item label="时间">
              <el-date-picker v-model="filter.createTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="filter.type">
                <el-option :label="$global.tradeTypeStr(item)" :value="item" v-for="(item, index) in tradeTypeList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="filter.status">
                <el-option :label="$global.tradeStatusStr(item)" :value="item" v-for="(item, index) in tradeStatusList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button type="primary" @click="exportExp">导出</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="tableData" :border="true" height="618" style="width: 100%">
            <el-table-column label="日期">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{ scope.row.tradeTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="金额">
              <template slot-scope="scope">
                <span
                  :style="{color: scope.row.tradeAmount > 0 ? '#f00' : '#666'}">{{ scope.row.tradeAmount > 0 ? '+' : '' }}{{ scope.row.tradeAmount.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                {{ $global.tradeTypeStr(scope.row.tradeType) }}
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                {{ $global.tradeStatusStr(scope.row.tradeStatus) }}
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">
                {{ scope.row.remark }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page="currentPage" :page-size="10" layout="prev, pager, next" :total="totalSize"
            @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx'

  export default {
    data() {
      return {
        tab: 1,
        userName: '',
        mobile: '',
        amount: 0,
        giveAmount: 0,
        consumeAmount: 0,
        nameEditShow: false,
        nameEdit: {
          userName: ''
        },
        passEditShow: false,
        passEdit: {
          oldPassword: '',
          passWord: '',
          confirmPassWord: ''
        },
        filter: {
          createTime: '',
          type: '',
          status: ''
        },
        currentPage: 1,
        pageSize: '10',
        totalSize: 0,
        tradeTypeList: ['', '101', '102', '103', '104', '105', '201', '202', '203', '204'],
        tradeStatusList: ['', '1', '2'],
        tableData: []
      };
    },
    mounted() {
      this.refresh();
    },
    methods: {
      refresh() {
        if (this.$store.state.loginStatus) {
          if (this.tab == 1) {
            this.$global.axios.post(this, '/sywl/api/user/userInfo', {}, res => {
              for (let key in res.data) {
                this[key] = res.data[key];
              }
              this.mobile = this.mobile.substr(0, 3) + '****' + this.mobile.substr(-4, 4);
            })
          } else {
            if (this.tableData.length == 0) {
              this.onSubmit();
            }
          }
        } else {
          this.$message.error('您还未登录，请登录');
          location.replace('/login');
        }
      },
      recharge() {
        this.$store.commit('rechargeChange');
      },
      submit(type) {
        let flag = true;
        let data = new Object();
        for (let key in this[type]) {
          if (this[type][key] == '') {
            flag = false;
          } else {
            data[key] = this[type][key];
          }
        }
        if (flag) {
          this.$global.axios.post(this, type == 'passEdit' ? '/sywl/api/user/updatePass' : '/sywl/api/user/updateUser',
            data, res => {
              this.$message.success('修改成功');
              location.reload();
            })
        } else {
          this.$message.error('您还有未填项，请检查');
        }
      },
      pageChange(t) {
        this.currentPage = t;
        this.onSubmit();
      },
      onSubmit() {
        this.$global.axios.post(this, '/sywl/api/user/accountDetail', {
          page: this.currentPage,
          limit: this.pageSize,
          tradeType: this.filter.type,
          tradeStatus: this.filter.status,
          beginTime: this.$global.format(this.filter.createTime[0], 'yyyy-MM-dd'),
          endTime: this.$global.format(this.filter.createTime[1], 'yyyy-MM-dd')
        }, res => {
          this.tableData = res.data.records;
          this.totalSize = Number(res.data.total);
        })
      },
      exportExp() {
        this.$global.axios.post(this, '/sywl/api/user/exportAccountDetail', {
          tradeType: this.filter.type,
          tradeStatus: this.filter.status,
          beginTime: this.$global.format(this.filter.createTime[0], 'yyyy-MM-dd'),
          endTime: this.$global.format(this.filter.createTime[1], 'yyyy-MM-dd')
        }, res => {
          let headName = [
            [
              '日期',
              '金额',
              '类型',
              '状态',
              '备注'
            ]
          ];
          res.data.forEach(ele => {
            headName.push([
              ele.tradeTime,
              (ele.tradeAmount > 0 ? '+' : '') + ele.tradeAmount.toFixed(2),
              this.$global.tradeTypeStr(ele.tradeType),
              this.$global.tradeStatusStr(ele.tradeStatus),
              ele.remark
            ]);
          })
          const worksheet = XLSX.utils.aoa_to_sheet(headName);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, '账户明细.xlsx');
        })
      }
    },
    watch: {
      tab() {
        this.refresh();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .userLeft {
    width: 192px;
    min-height: 776px;
    margin-right: 20px;
  }

  .userRight {
    width: calc(100% - 212px);
  }

  .userHeader {
    height: 197px;
    margin: 20px 0;
    flex-direction: column;
    background: url('/static/images/default-header-bg.png') no-repeat;
    background-size: cover;
    border-radius: 6px;

    &Border {
      border-radius: 50%;

      img {
        width: 90px;
        height: 90px;
      }
    }

    &Name {
      margin-top: 10px;
      font-size: 16px;
      color: #000;
    }

    &Mobile {
      margin-top: 6px;
      font-size: 13px;
      color: #999;
    }
  }

  .userMenu {
    height: calc(100% - 237px);
    padding: 24px 0;
    border-radius: 6px;
    background-color: #fff;
    box-sizing: border-box;

    &Item {
      height: 47px;
      font-size: 16px;
      color: #333;
      cursor: pointer;

      &.active {
        border-right: 3px solid #1875f0;
        background-color: #e6f7ff;
        color: #1875f0;
      }

      img {
        width: 13px;
        height: 14px;
        margin-right: 13px;
      }
    }
  }

  .userBody {
    position: relative;
    margin: 20px auto 0;
    padding: 29px 55px 73px;
    background-color: #fff;
    box-sizing: border-box;

    &Tag {
      position: absolute;
      top: 0;
      left: 0;
      width: 72px;
      height: 28px;
      background-color: rgba($color: #1875f0, $alpha: .15);
      border-radius: 0 0 10px 0;
      font-size: 14px;
      color: #1875f0;
      line-height: 28px;
      text-align: center;
    }

    &Param {
      height: 63px;
      padding: 0 31px;
      border-top: 1px solid #e2e2e2;
      font-size: 16px;
      color: #333;

      &:nth-child(2) {
        border-top: none;
      }

      &.haveEdit {
        background-color: rgba($color: #999, $alpha: .05);
      }

      &Label {
        width: 32px;
      }

      &Item {
        margin-left: 256px;
        text-align: left;
      }
    }

    &Fold {
      cursor: pointer;
    }

    &Edit {
      padding: 30px 58px 40px;
      border-top: 1px dashed #e2e2e2;

      &Label {
        width: 80px;
        font-size: 14px;
        color: #333;
        text-align: right;
      }

      .el-input {
        width: 280px;
        margin-bottom: 8px;
      }

      .el-button {
        margin-top: 8px;
      }
    }

    &Money {
      &>div {
        height: 32px;
        padding: 0 62px;
        align-items: baseline;
        flex-direction: column;
        border-left: 1px solid #999;
      }

      &Label {
        font-size: 14px;
        color: #666;

        img {
          margin-left: 6px;
        }
      }

      &Number {
        margin-top: 6px;
        font-size: 22px;
        font-weight: bold;
        color: #333;

        .el-button {
          width: 48px;
          height: 21px;
          margin-left: 18px;
          padding: 0;
          background-color: #f60;
          border-color: #f60;
          border-radius: 4px;
          font-size: 12px;
          line-height: 21px;
          color: #fff;
        }
      }
    }

    .el-form {
      text-align: left;
    }

    .el-pagination {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user.vue